import React, { useRef } from 'react';

import { IconChevronRightSmall } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useSectionViewTracking } from '../CustomHook/useSectionViewTracking';
import {
	LanguageLandingPage,
	LanguageLandingSectionType,
} from '../../../global-interfaces';
import s from './Header.scss';
import { LanguageLandingPageHeaderDataType } from '../../../../../api/public/static-pages-api';
import { LocalizedLink } from '../../../../../shared/public/LocalizedLink/LocalizedLink';
import { SlLogin } from '../../../../../login/public/SlLogin/SlLogin';

interface HeaderProps {
	data: LanguageLandingPageHeaderDataType;
}

export function Header({ data }: HeaderProps): JSX.Element {
	useStyles(s);
	const element = useRef<HTMLElement>(null);

	useSectionViewTracking({
		ref: element,
		sectionName: LanguageLandingPage.Header,
		sectionType: LanguageLandingSectionType.Main_Header_Page,
		sectionTitle: data.headerInfo.title,
	});

	return (
		<section
			className="sl-language__intro"
			ref={element}
			sl-test-data="cmpLanguageHeader"
		>
			<div className="sl-language__intro-breadcrumb">
				<LocalizedLink to="/learn"> Languages </LocalizedLink>
				<IconChevronRightSmall
					size={16}
					className="lp-landing-page-header__breadcrumb__icon"
				/>
				<p>{data.breadcrumb.language}</p>
			</div>
			<div className="sl-language__intro-header-container">
				<div className="sl-language__intro-header">
					<img
						src={data.headerInfo.courseLogo}
						alt={data.headerInfo.title}
						className="sl-language__intro-logo"
					/>
					<h1>{data.headerInfo.title}</h1>
					<p>{data.headerInfo.description}</p>
				</div>
			</div>
			<div className="sl-language__intro-signup">
				<SlLogin
					useRouter={false}
					signupTitle={data.signup.title}
					defaultRoute="signup"
					configs={{
						disableScrollToTop: true,
					}}
					cssClass="sl-language__signup"
					trackingPrefix="language-landing-page"
				/>
			</div>
		</section>
	);
}
